import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/notification';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { NotificationService } from '../../api/notification-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import * as notificationPageAction from '../actions/notification';

import Translator from '../../core/i18n';
import { param } from 'jquery';
const T = Translator.create();
const _logger = Log.create('notification-sagas');
const _notificationService = new NotificationService();

function* getNotifications(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = _notificationService.RequestNotificationsAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(notificationPageAction.SetNotifications(pageData, undefined, params.isOnlyCount));
            if (params.showTopNotification && pageData.filters.totalUnreadCount) {
                Notification.setNotification('success', T.t('r_new_notification'), 'topRight');
            }

        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getActivityNotifications(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const myYield = _notificationService.RequestActivityNotificationsAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(notificationPageAction.SetActivityNotifications(pageData, undefined, params.isOnlyCount));
            if (params.showTopNotification && pageData.filters.totalUnreadCount > 0) {
                Notification.setNotification('success', T.t('r_new_notification'), 'topRight');
            }
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getNotificationsAll(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const myYield = _notificationService.RequestNotificationsAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(notificationPageAction.SetNotificationsALL(pageData, undefined, params.isOnlyCount));
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getActivityNotificationsAll(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const myYield = _notificationService.RequestNotificationsAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(notificationPageAction.SetActivityNotificationsALL(pageData, undefined, params.isOnlyCount));
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}


function* getReadNotifications(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = _notificationService.RequestReadNotificationsAsync().then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 204) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {
            if (pageData) {
                yield put(notificationPageAction.SetNotifications(undefined, pageData));
            }
        }

        if (params.callback) {
            params.callback("success");
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getReadActiviyNotifications(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = _notificationService.RequestReadActivityNotificationsAsync().then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 204) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {
            if (pageData) {
                yield put(notificationPageAction.SetNotifications(undefined, pageData));
            }
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getReadNotificationId(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = _notificationService.RequestReadNotificationIdAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 204) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {
            if (pageData) {
                yield put(notificationPageAction.SetNotifications(undefined, pageData));
            }
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetNotifications() {
    yield takeEvery(constants.actions.GET_NOTIFICATIONS, getNotifications);
    return null;
}

export function* watchGetActivityNotifications() {
    yield takeEvery(constants.actions.GET_ACTIVITY_NOTIFICATIONS, getActivityNotifications);
    return null;
}

export function* watchGetNotificationsAll() {
    yield takeEvery(constants.actions.GET_NOTIFICATIONS_ALL, getNotificationsAll);
    return null;
}

export function* watchGetActivityNotificationsAll() {
    yield takeEvery(constants.actions.GET_ACTIVITY_NOTIFICATIONS_ALL, getActivityNotificationsAll);
    return null;
}

export function* watchGetReadNotifications() {
    yield takeEvery(constants.actions.GET_READ_NOTIFICATIONS, getReadNotifications);
    return null;
}

export function* watchGetReadActivityNotifications() {
    yield takeEvery(constants.actions.GET_READ_ACTIVITY_NOTIFICATIONS, getReadActiviyNotifications);
    return null;
}

export function* watchGetReadNotificationId() {
    yield takeEvery(constants.actions.GET_READ_NOTIFICATION_ID, getReadNotificationId);
    return null;
}

export function* NotificationSagas() {
    yield all([
        watchGetNotifications(),
        watchGetReadNotifications(),
        watchGetNotificationsAll(),
        watchGetReadNotificationId(),
        watchGetActivityNotifications(),
        watchGetReadActivityNotifications(),
        watchGetActivityNotificationsAll()

    ]);
}